import { authClient } from "@/lib/auth-client";

export type PhotoFileVariant = "thumb" | "display" | "original";

export function photoFileUrl(photoId: string, variant: PhotoFileVariant): string {
  return `/files/${encodeURIComponent(photoId)}/${variant}`;
}

/** "PDF" from "report.pdf"; "FILE" when the name has no extension. */
export function fileTypeLabel(fileName: string): string {
  const dot = fileName.lastIndexOf(".");
  return dot > 0 ? fileName.slice(dot + 1).toUpperCase() : "FILE";
}

const PROBE_INTERVAL_MS = 10_000;
let lastProbe = 0;

/**
 * An <img> can't say why it failed, and a session that ran out fails every tile at once.
 * So a failed image asks, at most every ten seconds, whether the session is still alive.
 */
export function checkSessionAfterImageError(): void {
  const now = Date.now();
  if (now - lastProbe < PROBE_INTERVAL_MS) return;
  lastProbe = now;
  void authClient.getSession().then(({ data, error }) => {
    if (!data && !error) window.location.assign("/login");
  });
}
